import Navbar from "../../components/Navbar";
import Footer from "./sections/Footer";
import { CheckCircle } from "lucide-react";
import { BarChart3, ShieldCheck, Smartphone, Users } from "lucide-react";

const About = () => {
  return (
    <>
      <Navbar />
      <main className="bg-white text-gray-900">

        {/* Intro */}
        <section className="py-28 bg-gradient-to-b from-secondary_1 via-white to-white border-b">
          <div className="max-w-5xl mx-auto px-6">
            <span className="inline-block mb-6 px-4 py-1 rounded-full bg-orange-100 text-orange-600 text-sm font-medium">
              درباره بامیزبان
            </span>

            <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-6">
              زیرساخت منوی دیجیتال
              <br />
              <span className="text-orange-500">برای کسب‌وکارهای غذایی</span>
            </h1>

            <p className="text-lg text-gray-600 max-w-3xl leading-relaxed">
              بامیزبان یک پلتفرم مدیریت منوی آنلاین است که به رستوران‌ها،
              کافه‌ها و مجموعه‌های غذایی کمک می‌کند منوی خود را
              سریع، دقیق و بدون وابستگی به اپلیکیشن در اختیار مشتری قرار دهند.
            </p>
          </div>
        </section>


        {/* Problem */}
        <section className="py-24 bg-gray-50">
          <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-6">
                چالش‌های رایج مدیریت منو
              </h2>
              <p className="text-gray-600 leading-relaxed">
                بسیاری از کسب‌وکارهای غذایی هنوز با ابزارهایی کار می‌کنند
                که نه برای مشتری مناسب است و نه برای مدیریت روزانه.
              </p>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-sm space-y-4">
              {[
                "تغییر قیمت با هزینه و تأخیر",
                "نبود دسترسی سریع برای مشتری",
                "طراحی نامناسب در موبایل",
                "عدم امکان تحلیل رفتار مشتری",
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3">
                  <CheckCircle className="text-orange-500 w-5 h-5" />
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>


        {/* Solution */}
        <section className="py-20">
          <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-3xl font-semibold mb-12">
              راه‌حل بامیزبان
            </h2>

            <div className="grid md:grid-cols-4 gap-8">
              <Feature
                icon={<Smartphone />}
                title="دسترسی سریع"
                desc="نمایش منو با اسکن QR، بدون نصب اپلیکیشن"
              />
              <Feature
                icon={<BarChart3 />}
                title="مدیریت هوشمند"
                desc="ویرایش منو، قیمت و آیتم‌ها در لحظه"
              />
              <Feature
                icon={<ShieldCheck />}
                title="پایدار و امن"
                desc="زیرساخت امن و قابل اطمینان"
              />
              <Feature
                icon={<Users />}
                title="تجربه کاربری"
                desc="طراحی بهینه برای موبایل و مشتری"
              />
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-24 bg-gradient-to-r from-gray-900 to-gray-800 text-white">
          <div className="max-w-6xl mx-auto px-6 grid sm:grid-cols-3 gap-10 text-center">
            <Stat value="+500" label="منوی فعال" />
            <Stat value="+100K" label="بازدید ماهانه" />
            <Stat value="99.9%" label="پایداری سرویس" />
          </div>
        </section>


        {/* Values */}
        <section className="py-20">
          <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-3xl font-semibold mb-10">
              ارزش‌های ما
            </h2>

            <div className="grid md:grid-cols-3 gap-8 text-gray-700">
              <p>
                ما به سادگی اعتقاد داریم. محصول خوب نیاز به آموزش پیچیده ندارد.
              </p>
              <p>
                شفافیت در قیمت‌گذاری و عملکرد، اصل اساسی بامیزبان است.
              </p>
              <p>
                رشد مشتریان ما، معیار موفقیت ماست.
              </p>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-28 bg-gray-50">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-extrabold mb-6">
              همکاری با بامیزبان را شروع کنید
            </h2>
            <p className="text-gray-600 mb-10 max-w-2xl mx-auto">
              اگر به دنبال راهکاری حرفه‌ای برای مدیریت منوی دیجیتال
              و بهبود تجربه مشتری هستید، بامیزبان برای شما ساخته شده است.
            </p>

            <a
              href="/register"
              className="inline-flex items-center justify-center px-12 py-4 rounded-2xl
                 bg-orange-500 text-white font-semibold
                 hover:bg-orange-600 shadow-lg hover:shadow-xl transition"
            >
              ایجاد حساب کاربری
            </a>
          </div>
        </section>


      </main>
      <Footer />
    </>

  );
};
function Feature({ icon, title, desc }) {
  return (
    <div className="group bg-white border rounded-3xl p-8
                    hover:shadow-lg transition-all duration-300">
      <div
        className="w-12 h-12 flex items-center justify-center rounded-xl
                   bg-orange-100 text-orange-500 mb-6
                   group-hover:bg-orange-500 group-hover:text-white transition"
      >
        {icon}
      </div>

      <h3 className="font-semibold text-lg mb-3">{title}</h3>
      <p className="text-sm text-gray-600 leading-relaxed">{desc}</p>
    </div>
  );
}
function Stat({ value, label }) {
  return (
    <div className="bg-white/5 backdrop-blur rounded-3xl py-10 px-6">
      <p className="text-4xl font-extrabold mb-3 text-orange-400">{value}</p>
      <p className="text-gray-300">{label}</p>
    </div>
  );
}

export default About;
